import { CSSProperties } from 'vue';

export const ingressFormInitData = {
  pullFrequency: '',
  global: false,
  enableMonitoring: false,
  globalPullFrequencyMins: '',
  tagsCondition: '',
  tags: [{}] as { key: string; value: string }[],
};

export const getCardBodyStyle: CSSProperties = {
  height: '420px',
  width: '100%',
  padding: '1.25rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};
